// extracted by mini-css-extract-plugin
export var chevron = "_s-d";
export var disabled = "_s-b";
export var error = "_s-c";
export var hideBorder = "_s-1";
export var icon = "_s-e";
export var input = "_s-0";
export var large = "_s-f";
export var open = "_s-9";
export var placeholder = "_s-a";
export var regular = "_s-5";
export var singleRowInput = "_s-2";
export var singleSelectInput = "_s-3 _s-0";
export var small = "_s-4";
export var spinnerContainer = "_s-h";
export var tag = "_s-7";
export var tagsContainer = "_s-8";
export var tagsInput = "_s-6 _s-0";
export var xSmall = "_s-g";